const {LINK_ADMIN_ROOT, LINK_ADMIN_CUSTOMERS, LINK_ADMIN_RETAILERS} = require('../constants/links');

const getAdminLink = (...rest) => [LINK_ADMIN_ROOT, ...rest].join('')

const adminLinkCtor = (section) => (...rest) => getAdminLink(section, ...rest);

const getAdminCustomersLink = adminLinkCtor(LINK_ADMIN_CUSTOMERS);
const getAdminRetailersLink = adminLinkCtor(LINK_ADMIN_RETAILERS);

module.exports = {
  getAdminLink: getAdminLink,
  getAdminCustomersLink: getAdminCustomersLink,
  getAdminRetailersLink: getAdminRetailersLink,
};
